import { FormControl, FormGroup } from '@angular/forms';
import { IOption } from 'src/app/components/shared/form/components/form-select/form-select.component';

export const CONSTS = {
  HEADER: $localize`Group COD Extract`,
  LABEL: $localize`Date`,
  REPORT_LABEL: $localize`Report`,
  FROM_LABEL: $localize`From`,
  TO_LABEL: $localize`To`,
  DATE_LABEL: $localize`Date`,
  ROUTE_LABEL: $localize`Route`,
};

export enum Reports {
  GROUP_COD_EXTRACT,
  COD_RECONCILE_REPORT,
  COD_COLLECTED_CLEARED,
  COD_OUTSTANDING,
}

export const REPORT_OPTIONS: IOption[] = [
  {
    label: $localize`COD Reconcile Report`,
    value: Reports.COD_RECONCILE_REPORT,
  },
  {
    label: $localize`COD Collected/ Cleared`,
    value: Reports.COD_COLLECTED_CLEARED,
  },
];

export const DOWNLOAD_FILE_NAMES = {
  [Reports.COD_RECONCILE_REPORT]: 'Group-COD-Reconcile-Report',
  [Reports.COD_COLLECTED_CLEARED]: 'Group-COD-Collected-Report',
  [Reports.COD_OUTSTANDING]: 'Group-COD-Outstanding-Report',
};

export const MOCK_GROUP_COD_EXTRACT = {
  instance: [
    {
      codSubmitDate: null,
      stopType: 'D',
      trackingNumber: '1Z1271220211140773',
      shipperNumber: '127122',
      locationCode: 'PECHT',
      loop: 'QA2',
      locationSlic: '1375',
      paymentType: null,
      codSubmitAmount: null,
      stopDate: '11-14-2023',
    },
  ],
};

type GroupCodExtractFormField = {
  date: FormControl<Date>;
};

export type GroupCodExtractFormGroup =
  FormGroup<GroupCodExtractFormField> | null;
